import { define, prop } from "@/components/builder/utils";

import BasePreview from "../base";

function ProgressValuePreview({ ...props }) {
  return <BasePreview {...props}>
    <div style={{ width: '70%' }}>
      70%
    </div>
  </BasePreview>
}

function ProgressValueHTML({ calculation, range: { start = 0, end = 100 } = {}, attributes }) {
  const calculatePercentage = getCalculatePercentage(calculation)
  const calculateRange = getCalculateRange(start, end)
  return <>
    <div id="progress-bar" {...attributes}></div>
    <script type="text/javascript" dangerouslySetInnerHTML={{
      __html: `
        (function() {
          var progressElement = document.currentScript && document.currentScript.previousElementSibling
          var handleUpdateProgress = function(event, progressStorage){
            var calculatePercentage = ${calculatePercentage.toString()};
            var calculateRange = ${calculateRange.toString()};

            if (!progressElement) {
              return;
            }

            if (event) {
              localStorage.setItem("progress", JSON.stringify(event.detail.progress))
            }

            var progress = event && event.detail && event.detail.progress || progressStorage

            var step = progress.step || 0
            var total = progress.total || 0

            if (progress.progressCurrent >= progress.progressTotal) {
              localStorage.removeItem("progress")
            }

            var percentage = calculatePercentage(step, total, progress)
            var result = calculateRange(percentage)

            progressElement.style.width = result + "%"
            progressElement.innerText = result + "%"
          }

          document.addEventListener('update-progress-bar', handleUpdateProgress)

          handleUpdateProgress(null, JSON.parse(localStorage.getItem("progress") || '{ "total": 1, "step": 0, "progressTotal": 1, "progressCurrent": 0 }'))
        })()`,
    }} />
  </>
}

export default define('progress-value', ProgressValuePreview, ProgressValueHTML)
  .property(prop.stylePattern())
  .property(prop.predefined.customClass())
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.textAlign())
  .property(prop.predefined.textShadow())
  .property(prop.group('Calculation', 'calculation').unique()
    .category('default')
    .options(prop.options()
      .add('Based on rendered step', 'current')
      .add('Based on completed Steps', 'completed')
      .add('Ignore skipping (original slots)', 'raw'),
    )
    .own()
    .ignoreDevice(true))
  .property(prop.new('Range', 'range', 'progressRange').category('default').own().ignoreDevice(true))
  .defaultProps({
    range: {
      start: 0,
      end: 100,
    },
    calculation: 'raw',
    className: 'min-w-min',
    size: {
      height: 'h-full',
    },
    space: {
      padding: 'px-2',
    },
    border: {
      radius: {
        rounded: '3xl',
      },
    },
    fontSize: 'xs',
    textAlign: {
      horizontal: 'right',
      vertical: 'middle',
    },
    textColor: 'gray-50',
    background: {
      color: 'gray-500',
    },
  })
  .build()

const getCalculatePercentage = (calculation = 'raw') => {
  const func = {
    current: `function(step, total) { return (step / total) * 100; }`,
    completed: `function(step, total) { return ((step - 1) / total) * 100; }`,
    raw: `function(step, total, progress) { return (progress.progressCurrent / progress.progressTotal) * 100; }`,
  }[calculation]
  return func
}

const getCalculateRange = (start, end) => {
  const func = `function(percentage) { return Math.round(${start} + ((${end} - ${start}) * percentage) / 100); }`
  return func
}
